import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { QuillEditorComponent, QuillViewHTMLComponent } from 'ngx-quill';

@Component({
  selector: 'app-text-editor-type',
  imports: [QuillEditorComponent, QuillViewHTMLComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './text-editor-type.component.html',
  styleUrl: './text-editor-type.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextEditorTypeComponent extends FieldType {
  override defaultOptions = {
    props: {
      modules: {
        syntax: false,
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
          ],
        },
      },
    },
  };
}
